export const BorderCircle = () => {
  return (
    <div className="mt-[5px]">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
      >
        <circle cx="7" cy="7" r="5.5" stroke="#2E2E2E" strokeWidth="3" />
      </svg>
    </div>
  );
};
